import {Button} from "primereact/button";
import {Link} from "react-router-dom";

export const eventDate = item => {
	return item?.date;
};

export const eventName = item => {
	return (
		<div>
			<div className="fs-6 fw-bold">
				{item?.name} ({item?.location.title_am})
			</div>
			<div className="fw-normal">{item?.project.full_name_am}</div>
		</div>
	);
};

export const eventAction = item => (
	<Link to={`/beneficiaries/edit_event/${item.id}/`}>
		<Button icon="pi pi-arrow-right" severity="secondary" rounded />
	</Link>
);
